import $ from "jquery";


const OLD_FILTER = false;

const careerFilter = () => {
  const init = () => {
    accordion();
    
    if(OLD_FILTER){
      onHandleClick();
    }
    onHandleSearch();
  };

  const accordion = () => {
    const el = {
      button: ".js-Filter__Group__Text",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function () {
      const dataFor = $(this).data("for");
      $(`#${dataFor}`).toggle(300);
      $(this).find("i").toggleClass("reverse");
    });
  };

  const onHandleClick = () => {
    const el = {
      input: ".js-Filter__Input",
    };

    if ($(el.input).length === 0) return;

    $(document).on("change", el.input, function () {
      window.location.href = $(this).val() + "#career-opportunities";
    });
  };

  const onHandleSearch = () => {
    const el = {
      form: ".js-CareerSearchBar",
      input: ".js-SearchBar__Input",
    };

    if ($(el.form).length === 0) return;

    $(document).on("submit", el.form, function (e) {
      e.preventDefault();
      const wl = window.location;
      const url = `${wl.origin}${wl.pathname}?search=${$(
        el.input
      ).val()}#career-opportunities`;

      wl.href = url;
    });
  };

  init();
};

careerFilter();
